import { EventEmitter } from './events/EventEmitter';

export class ApplicationBase extends EventEmitter {

}
